import React,{useState, useEffect}  from 'react';

import Sides from '../Bars/Pythonsidebar';

import Button from 'react-bootstrap/Button'
import { Helmet } from "react-helmet";

function Pfunctionoverride(){

  const [padding, setWindowpadding] = useState(0);
  const [width, setWindowWidth] = useState(0);
  useEffect(() => {
    updateDimensions()

    window.addEventListener('resize', updateDimensions)
    return () => window.removeEventListener('resize', updateDimensions)
  }, [])

  const updateDimensions = () => {
    const width = window.innerWidth
    setWindowWidth(width)
    if (width < 998) {
      setWindowpadding(2.5)
    } else {
      setWindowpadding(14)
    }
  }

  
  
return(
     <div>
<Sides/>
<Helmet>
 
  <title>Learn Free Python overriding Beginners Tutorials CodeExampler</title>
<meta name="description" content="Python Function overriding tutorial for beginners.Python override method used to override 2-3 or more child classes with the same name but different Work and child Class Access properties with parent function properties." />
<meta name="keywords" content="codeexampler,programming language,tutorial for begineers,Function overriding in Python,Function overloading in Python example,python override method" />
<link rel="canonical" href="https://www.codeexampler.com/python-function-overriding" />
</Helmet>

<div className='lg:pl-56'>


    <h1 className="m-4 mh1">python override method</h1>
    <div className="first">
        <a href="/python-function-overloading">   <Button className="ab" variant="primary" size="lg">&#60; Previous</Button></a> 
        <a href="/python-exception-handling">   <Button className="cd" variant="primary" size="lg"> Next &#62;</Button></a> 
        </div>


        <p className="mt-4 para">Python override method used to override 2-3 or more child classes with the same name but different Work and child Class Access properties with parent function properties.
</p>

  
<h2 className='headings'>Python override method Example:</h2>
        <div style = {{ background:"#0f0e33",width:"94%",marginLeft:"3%",paddingLeft:"2%",borderRadius: "20px"}} >
       <pre style={{maxHeight:"500vh"}}>
           <code >
             {"\n"}
                 <span className="qwerty-6">class </span>
                 <span className="qwerty-4">a</span>
                 <span className="qwerty-1">:</span>
             {"\n"}
                 <span className="qwerty">    def </span>
                 <span className="qwerty-8">over</span>
                 <span className="qwerty-1">(</span>
                 <span className="qwerty-5">self</span>
                 <span className="qwerty-1">)</span>
                 <span className="qwerty-1">:</span>
                 {"\n"}
                 <span className="qwerty-3">        print</span>
                 <span className="qwerty-1">("</span>
                 <span className="qwerty-10">This is a</span>
                 <span className="qwerty-1">")</span>
             {"\n"}
                 <span className="qwerty-6">class </span>
                 <span className="qwerty-2">b</span>
                 <span className="qwerty-1">(</span>
                 <span className="qwerty-4">a</span>
                 <span className="qwerty-1">)</span>
                 <span className="qwerty-1">:</span>
             {"\n"}
                 <span className="qwerty">    def </span>
                 <span className="qwerty-8">over</span>
                 <span className="qwerty-1">(</span>
                 <span className="qwerty-5">self</span>
                 <span className="qwerty-1">)</span>
                 <span className="qwerty-1">:</span>
                 {"\n"}
                 <span className="qwerty-3">        print</span>
                 <span className="qwerty-1">("</span>
                 <span className="qwerty-10">This is b</span>
                 <span className="qwerty-1">")</span>
                 {"\n"}
                 <span className="qwerty-7">Obj</span>
                 <span className="qwerty-1"> = </span>
                 <span className="qwerty-2">b</span>
                 <span className="qwerty-1">()</span>
                 {"\n"}
                 <span className="qwerty-7">Obj</span>
                 <span className="qwerty">.</span>
                 <span className="qwerty-8">over</span>
                 <span className="qwerty-1">(</span>
                 <span className="qwerty-1">)</span>
             {"\n"}{"\n"}
                  </code>
         </pre>
         </div>          
         <h5 className='headings'> Output : </h5>
          <div style = {{ background:"#0f0e33",width:"94%",marginLeft:"3%",paddingLeft:"2%",borderRadius: "20px"}} >
             <pre style={{maxHeight:"500vh"}}>
                 <code >
                     {"\n"}
                         <span className="qwerty-2">This is b</span>
                         {"\n"}      {"\n"}      
               </code>
                 </pre>
                 </div>

  <h1 className="mt-5">  </h1>
     
  <div className="back">
        <a href="/python-function-overloading">   <Button className="ab" variant="primary" size="lg">&#60; Previous</Button></a> 
        <a href="/python-exception-handling">   <Button className="cd" variant="primary" size="lg"> Next &#62;</Button></a> 
        </div>
    </div></div>
)

}
export default Pfunctionoverride;